/**
 * @Desc 我的任务 API
 */
import { Get, Patch, Post, Delete } from 'utils/axios';

/** 
 * @desc 获取班级小组列表
 * @param {object} param 
 */
export function reqGetClassesAndGroups(params) {

  let url = '/api/v1/studentTask/getClassesAndGroups';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })

}

/** 
 * @desc 获取任务管理列表
 * @param {object} param 
 */
export function reqGetTaskList(params) {

  let url = '/api/v1/studentTask/list';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })

}

/** 
 * @desc 查询任务学习内容
 * @param {object} param 
 */
export function reqGetTaskAndLearningInfo(params) {
  let url = `/api/v1/studentTask/getTaskAndLearningInfo/${params.learningTaskId}`;
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/** 
 * @desc 获取备课详情
 * @param {object} param 
 */
export function reqGetPrepareDetail(params) {
  let url = `/api/v1/resourcePrepare/${params.customResourceId}`;
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



/** 
 * @desc 查看学生任务结果
 * @param {object} param 
 */
export function reqGetStudentAnswerInfo(params) {
  let url = '/api/v1/studentTask/getStudentAnswerInfo';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}




/** 
 * @desc 获取学习管理详情
 * @param {object} param 
 */
export function reqGetLearningDetail(params) {
  return new Promise((resolve, reject) => {

    let obj = {
      "code": 0,
      "message": "success",
      "serverTimestamp": 1590647880442,
      "data": {
        "learningDataId": 131,
        "learningBaseInfo": {
          "chapterOneTitle": "2.位置",
          "chapterOneId": 1,
          "description": "课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展课外拓展",
          "title": "课外拓展一",
          "subjectId": 1,
          "chapterThreeTitle": "",
          "chapterTwoTitle": "",
          "chapterId": 0,
          "levelId": 1,
          "volumeId": 1,
          "learningRevision": 1,
          "learningId": 171,
          "subjectName": "数学",
          "learningDataId": 151,
          "editionName": "人教版",
          "chapterTwoId": 0,
          "editionId": 1,
          "estimated": 120,
          "levelName": "小学",
          "chapterThreeId": 0,
          "target": "课外拓展",
          "difficulty": 1,
          "volumeName": "一年级上册",
          "remarks": "课外拓展"
        },
        "taskBaseInfo":{
          "classOrGroupName":"奥数培训班1、奥数培训班2",
          "learningDetailCount":32,
          "exerciseId":65,
          "startTime":1591999200000,
          "dueTime":1592143200000,
          "totalStudentCount":12,
          "completedStudentCount":0,
          "learningId":171,
          "learningTaskId":117,
          "status":2
        },
        "exerciseDetailList": [
          {
            "exerciseId": 65,
            "sortOrder": 0,
            "id": 346,
            "type": 1,
            "params": {
              "question": "用一根56厘米长的铁丝,恰好可以焊成-个长6厘米、宽4厘米、高( )厘 米的长方体教具。",
              "options": [
                {
                  "isCorrect": false,
                  "answer": "2"
                },
                {
                  "isCorrect": false,
                  "answer": "3"
                },
                {
                  "isCorrect": true,
                  "answer": "4"
                },
                {
                  "isCorrect": false,
                  "answer": "5"
                }
              ]
            }
          },
          {
            "exerciseId": 65,
            "sortOrder": 1,
            "id": 347,
            "type": 1,
            "params": {
              "question": "-个长方体木块，长8厘米，宽和高都是6厘米，要截去一个最大的正方体，剩 下长方体表面积是_平方厘米",
              "options": [
                {
                  "isCorrect": false,
                  "answer": "48"
                },
                {
                  "isCorrect": false,
                  "answer": "84"
                },
                {
                  "isCorrect": true,
                  "answer": "120"
                }
              ]
            }
          },
          {
            "exerciseId": 65,
            "sortOrder": 2,
            "id": 353,
            "type": 2,
            "params": {
              "question": "下面哪些说法是对的",
              "options": [
                {
                  "isCorrect": false,
                  "answer": "一堆货物，第一天运走这堆货物的3，第二天运走余下的3，两天运走的一样多。"
                },
                {
                  "isCorrect": false,
                  "answer": "4米的1/7和1米的1/7同样长"
                },
                {
                  "isCorrect": true,
                  "answer": "两个合数的和如果是质数，则这两个合数一定是互质数"
                },
                {
                  "isCorrect": false,
                  "answer": "中位数就是这组数据中间的数"
                },
                {
                  "answer": "四个相同的正方体可以拼成一个大的正方体",
                  "isCorrect": true
                }
              ]
            }
          },
          {
            "exerciseId": 65,
            "sortOrder": 2,
            "id": 348,
            "type": 3,
            "params": {
              "type": 3,
              "question": "长方体是特殊的正方体",
              "isCorrect": false
            }
          },
          {
            "exerciseId": 65,
            "sortOrder": 3,
            "id": 349,
            "type": 3,
            "params": {
              "type": 3,
              "question": "正方体是特殊的长方体",
              "isCorrect": true
            }
          },
          {
            "exerciseId": 65,
            "sortOrder": 4,
            "id": 350,
            "type": 4,
            "params": {
              "question": "长方体的高锯掉2厘米后，表面积减少了72平方厘米，剩下的恰好是一一个正方体，原长方体的表面积是多少?",
              "min": "10",
              "max": "100"
            }
          },
          {
            "exerciseId": 65,
            "sortOrder": 5,
            "id": 351,
            "type": 4,
            "params": {
              "question": "长方体油箱，长5分米，宽0.4米，高16分米，注满油，倒入一个底面边长是4分米的正方形高25分米的长方体容器中，油面离油箱顶的高度是多少?",
              "min": "10",
              "max": 200
            }
          },
          {
            "exerciseId": 65,
            "sortOrder": 6,
            "id": 352,
            "type": 4,
            "params": {
              "question": "张翔生日，肖鸣想送给好朋友-套书。他买了一套书共3本，每本书长是20厘米、宽是14厘米、厚是5厘米，，要求书店叔叔包个漂亮的包装。你帮叔叔算算应怎样包装最省料? (计算并画出草图)",
              "min": "10",
              "max": 200
            }
          }
        ],
        "learningDetailList": [
          {
            "isDownload": true,
            "resourceId": 112405,
            "chapterOneId": 3611,
            "sourceResourceType": 1,
            "type": 1,
            "subjectId": 1,
            "duration": 152,
            "levelId": 1,
            "fileUrl": "最大的鱼.vs4",
            "id": 703,
            "learningId": 171,
            "resourceFileSize": 21566125,
            "dataType": 1,
            "editionId": 1,
            "resourceTitle": "最大的鱼",
            "trailType": 0,
            "authorId": 0,
            "customResourceId": 0,
            "coverUrl": "http://mvr-learning.viewshare.net/resource/videos/112405/最大的鱼_s.jpg",
            "sourceStatus": 1,
            "detailDataId": 2221,
            "sortOrder": 0,
            "documentId": 2221,
            "isShadow": false,
            "detailSourceType": 3,
            "fileType": 2,
            "resourceType": 1
          },
          {
            "isDownload": true,
            "resourceId": 500025,
            "previewUrl": "http://mvr-learning.viewshare.net/resource/teachingPlan/500025/tp/【教案】2.位置 第1课时.pdf",
            "chapterOneId": 1,
            "sourceResourceType": 5,
            "type": 5,
            "subjectId": 1,
            "levelId": 1,
            "fileUrl": "【教案】2.位置 第1课时.docx",
            "id": 704,
            "learningId": 171,
            "resourceFileSize": 18355,
            "dataType": 1,
            "chapterTwoId": 2,
            "editionId": 1,
            "resourceTitle": "2.位置 第1课时",
            "trailType": 0,
            "authorId": 0,
            "customResourceId": 943,
            "coverUrl": "http://mvr-learning.viewshare.net/resource/teachingPlan/500025/teachingPlan.png",
            "sourceStatus": 1,
            "detailDataId": 2220,
            "sourceType": 5,
            "sortOrder": 1,
            "documentId": 2220,
            "isShadow": false,
            "detailSourceType": 3,
            "fileType": 4,
            "shareSourceStatus": 1,
            "resourceType": 1
          },
          {
            "isDownload": true,
            "resourceId": 200051,
            "chapterOneId": 9,
            "sourceResourceType": 2,
            "type": 2,
            "subjectId": 1,
            "levelId": 1,
            "fileUrl": "被减数是6或7的减法游戏.zip",
            "id": 705,
            "learningId": 171,
            "resourceFileSize": 2298150,
            "dataType": 1,
            "chapterTwoId": 10,
            "editionId": 1,
            "resourceTitle": "被减数是6或7的减法游戏",
            "trailType": 0,
            "authorId": 0,
            "customResourceId": 0,
            "coverUrl": "http://mvr-learning.viewshare.net/resource/phets/200051/被减数是6或7的减法游戏_封面.png",
            "sourceStatus": 1,
            "detailDataId": 2219,
            "sortOrder": 2,
            "documentId": 2219,
            "isShadow": false,
            "detailSourceType": 3,
            "fileType": 9,
            "resourceType": 1
          },
          {
            "isDownload": true,
            "resourceId": 600025,
            "chapterOneId": 1,
            "sourceResourceType": 6,
            "type": 6,
            "subjectId": 1,
            "levelId": 1,
            "fileUrl": "【课件】2.位置 第1课时.ppa",
            "id": 706,
            "learningId": 171,
            "resourceFileSize": 858428,
            "dataType": 1,
            "chapterTwoId": 2,
            "editionId": 1,
            "resourceTitle": "2.位置 第1课时",
            "trailType": 0,
            "authorId": 0,
            "customResourceId": 1027,
            "coverUrl": "http://mvr-learning.viewshare.net/resource/coursewares/600025/coursewares.png",
            "sourceStatus": 1,
            "detailDataId": 2218,
            "sourceType": 6,
            "sortOrder": 3,
            "documentId": 2218,
            "isShadow": false,
            "detailSourceType": 3,
            "fileType": 5,
            "shareSourceStatus": 1,
            "resourceType": 1
          },
          {
            "isDownload": true,
            "resourceId": 400024,
            "previewUrl": "http://mvr-learning.viewshare.net/resource/examination/400024/【习题】2.位置 第1课时.pdf",
            "chapterOneId": 1,
            "sourceResourceType": 4,
            "type": 4,
            "subjectId": 1,
            "levelId": 1,
            "fileUrl": "【习题】2.位置 第1课时.docx",
            "id": 707,
            "learningId": 171,
            "resourceFileSize": 64987,
            "dataType": 1,
            "chapterTwoId": 2,
            "editionId": 1,
            "resourceTitle": "2.位置 第1课时",
            "trailType": 0,
            "authorId": 0,
            "customResourceId": 0,
            "coverUrl": "http://mvr-learning.viewshare.net/resource/examination/400024/examination.png",
            "sourceStatus": 1,
            "detailDataId": 2217,
            "sortOrder": 4,
            "documentId": 2217,
            "isShadow": false,
            "detailSourceType": 3,
            "fileType": 4,
            "resourceType": 1
          },
          {
            "isDownload": true,
            "resourceId": 302131,
            "chapterOneId": 8,
            "sourceResourceType": 3,
            "type": 3,
            "subjectId": 1,
            "duration": 182,
            "levelId": 1,
            "fileUrl": "小学数学-120-图形的拼组-于金荣.vs4",
            "id": 708,
            "learningId": 171,
            "resourceFileSize": 24482109,
            "dataType": 1,
            "chapterTwoId": 3569,
            "editionId": 1,
            "resourceTitle": "图形的拼组",
            "trailType": 0,
            "authorId": 0,
            "customResourceId": 0,
            "coverUrl": "http://mvr-learning.viewshare.net/resource/microCourse/302131/小学数学-120-图形的拼组-于金荣_s.jpg",
            "sourceStatus": 1,
            "detailDataId": 2216,
            "sortOrder": 5,
            "documentId": 2216,
            "isShadow": false,
            "detailSourceType": 3,
            "fileType": 2,
            "resourceType": 1
          },
          {
            "resourceFileSize": 832976,
            "dataType": 3,
            "resourceTitle": "rule.rar",
            "coverUrl": "",
            "detailDataId": 2214,
            "fileMime": "rar",
            "sortOrder": 6,
            "documentId": 2214,
            "fileUrl": "group1/M00/00/05/wKgAoF7gVJ6ATnP-AAy10DyBFZA052.rar",
            "id": 709,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 8,
            "status": 1
          },
          {
            "resourceFileSize": 6656,
            "dataType": 3,
            "resourceTitle": "upload-test5.xls",
            "coverUrl": "",
            "detailDataId": 2213,
            "fileMime": "xls",
            "sortOrder": 7,
            "documentId": 2213,
            "fileUrl": "group1/M00/00/05/wKgAoF7gVIuAOUr7AAAaAIb5KS4368.xls",
            "id": 710,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 7,
            "status": 1
          },
          {
            "resourceFileSize": 23481303,
            "dataType": 3,
            "resourceTitle": "G1606短歌行.mp4",
            "coverUrl": "http://mvr-learning.viewshare.net/videoCover/wKgAoF7gVCiAHeOQAWZL10exRKA409.jpg",
            "duration": 612,
            "detailDataId": 2209,
            "fileMime": "mp4",
            "sortOrder": 8,
            "documentId": 2209,
            "fileUrl": "group1/M00/00/05/wKgAoF7gVCiAHeOQAWZL10exRKA409.mp4",
            "id": 711,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 2,
            "status": 1
          },
          {
            "resourceFileSize": 938548,
            "dataType": 3,
            "resourceTitle": "奥尔夫音乐 - 快乐的时间.mp3",
            "coverUrl": "",
            "detailDataId": 2210,
            "fileMime": "mp3",
            "sortOrder": 9,
            "documentId": 2210,
            "fileUrl": "group1/M00/00/05/wKgAoF7gVCiAbRLfAA5SND-ONCU754.mp3",
            "id": 712,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 1,
            "status": 1
          },
          {
            "resourceFileSize": 156691,
            "dataType": 3,
            "resourceTitle": "霸王龙.jpg",
            "coverUrl": "http://mvr-learning.viewshare.net/group1/M00/00/05/wKgAoF7gVCiAHQD_AAJkE_817Ek512.jpg",
            "detailDataId": 2211,
            "fileMime": "jpg",
            "sortOrder": 10,
            "documentId": 2211,
            "fileUrl": "group1/M00/00/05/wKgAoF7gVCiAHQD_AAJkE_817Ek512.jpg",
            "id": 713,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 3,
            "status": 1
          },
          {
            "resourceFileSize": 3608453,
            "dataType": 3,
            "resourceTitle": "生活探索+中班+小猪威比的奇妙世界+21+雨伞下的快乐 - 副本(2).pptx",
            "coverUrl": "",
            "detailDataId": 2212,
            "fileMime": "pptx",
            "sortOrder": 11,
            "documentId": 2212,
            "fileUrl": "group1/M00/00/05/wKgAoF7gVCiAP3fzADcPhVHrsBk84.pptx",
            "id": 714,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 5,
            "status": 1
          },
          {
            "resourceFileSize": 29262,
            "dataType": 3,
            "resourceTitle": "生活探索+中班+小猪威比的奇妙世界+21+雨伞下的快乐.jpg",
            "coverUrl": "http://mvr-learning.viewshare.net/group1/M00/00/05/wKgAoF7gU-qAIuTJAAByThRohFA729.jpg",
            "detailDataId": 2205,
            "fileMime": "jpg",
            "sortOrder": 12,
            "documentId": 2205,
            "fileUrl": "group1/M00/00/05/wKgAoF7gU-qAIuTJAAByThRohFA729.jpg",
            "id": 715,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 3,
            "status": 1
          },
          {
            "resourceFileSize": 810391,
            "dataType": 3,
            "resourceTitle": "生活探索+中班+小猪威比的奇妙世界+21+雨伞下的快乐 - 副本(1).doc",
            "coverUrl": "",
            "detailDataId": 2206,
            "fileMime": "doc",
            "sortOrder": 13,
            "documentId": 2206,
            "fileUrl": "group1/M00/00/05/wKgAoF7gU--Af7Z0AAxdl4DPL9U300.doc",
            "id": 716,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 4,
            "status": 1
          },
          {
            "resourceFileSize": 0,
            "dataType": 3,
            "resourceTitle": "test.txt",
            "coverUrl": "",
            "detailDataId": 2207,
            "fileMime": "txt",
            "sortOrder": 14,
            "documentId": 2207,
            "fileUrl": "group1/M00/00/05/wKgAoF7gVAuAWliMAAAAAAAAAAA223.txt",
            "id": 717,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 0,
            "status": 1
          },
          {
            "resourceFileSize": 324215359,
            "dataType": 3,
            "resourceTitle": "CJ-ST-41-雨伞.mp4",
            "coverUrl": "http://mvr-learning.viewshare.net/videoCover/wKgAoF7gVBuAe4wnE1MiP54JANI316.jpg",
            "duration": 314,
            "detailDataId": 2208,
            "fileMime": "mp4",
            "sortOrder": 15,
            "documentId": 2208,
            "fileUrl": "group1/M00/00/05/wKgAoF7gVBuAe4wnE1MiP54JANI316.mp4",
            "id": 718,
            "learningId": 171,
            "detailSourceType": 3,
            "fileType": 2,
            "status": 1
          }
        ],
        "learningRevision": 1
      }
    }
    setTimeout(() => {
      resolve(obj);
    }, 300);
  });
  let url = `/api/v2/getLearningInfo/${params.learningDataId}`;
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/** 
 * @desc 任务状态修改
 * @param {object} param 
 */
export function reqTaskStatusModify(params) {
  
  let url = '/api/v1/studentTask/update';
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
  return new Promise((resolve, reject) => {
    let obj = {
      "code": 0,
      "message": "success",
      "serverTimestamp": 1590647880442,
      "data": {
        "allWatched": false
      }
    }
    setTimeout(() => {
      resolve(obj);
    }, 300);
  });
} 
























/** 
 * @desc 创建分配任务
 * @param {object} param 
 */
export function reqTaskAssignment(params) {
  let url = '/api/v2/learningTask';
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/** 
 * @desc 取消任务分配
 * @param {object} param 
 */
export function reqCancelTaskAssignment(params) {
  let url = `/api/v2/learningTask/cancel/${params.learningTaskId}`;
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}


/** 
 * @desc 修改任务分配的时间
 * @param {object} param 
 */
export function reqUpdateTaskAssignmentDate(params) {
  let url = `/api/v2/learningTask/updateTaskTime/${params.learningTaskId}`;
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}



/** 
 * @desc 获取任务详情学生列表
 * @param {object} param 
 */
export function reqTaskStudentList(params) {
  let url = `/api/v2/learningTask/${params.learningTaskId}`;
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
  return new Promise((resolve, reject) => {

    let obj = {
      "code": 0,
      "message": "success",
      "serverTimestamp": 1588230824271,
      "data": {
        "learningDataId": 1,
        "learningTitle": "济南的冬天课后caiciacai",
        "studentList": [
          {
            "studentId": 5,
            "classOrGroupName": "数学尖子生实验班",
            "objectiveTotal": 3,
            "completedTime": 1588219196000,
            "studentName": "李4天",
            "estimated": 1440,
            "exerciseStatus": 2,
            "objectiveCorrectedNum": 2,
            "isExcellent": true,
            "learningStatus": 2
          },
          {
            "studentId": 6,
            "classOrGroupName": "数学尖子生实验班",
            "objectiveTotal": 3,
            "studentName": "李5天",
            "exerciseStatus": null,
            "objectiveCorrectedNum": null,
            "isExcellent": false,
            "learningStatus": null
          },
          {
            "studentId": 7,
            "classOrGroupName": "数学尖子生实验班",
            "objectiveTotal": 3,
            "studentName": "李6天",
            "exerciseStatus": null,
            "objectiveCorrectedNum": null,
            "isExcellent": false,
            "learningStatus": null
          },
          {
            "studentId": 1,
            "classOrGroupName": "七年级（1）班",
            "objectiveTotal": 3,
            "studentName": "李0天",
            "exerciseStatus": null,
            "objectiveCorrectedNum": null,
            "isExcellent": false,
            "learningStatus": null
          },
          {
            "studentId": 2,
            "classOrGroupName": "七年级（1）班",
            "objectiveTotal": 3,
            "studentName": "李1天",
            "exerciseStatus": null,
            "objectiveCorrectedNum": null,
            "isExcellent": false,
            "learningStatus": null
          }
        ]
      }
    };
    setTimeout(() => {
      resolve(obj);
    }, 300);
  });


}


/** 
 * @desc 学生的学习任务点评
 * @param {object} param 
 */
export function reqReviewStudentLearningTask(params) {
  let url = `/api/v2/learningTask/reviewTask/${params.studentTaskId}`;
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}


